import React, { useEffect } from 'react';
import {poa} from '../../json/poa';
import './Poa.css';

const Poasitem = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container'>
            <div className='row'>
                <div>
                    <h3 className='title'>Programa Operativo Anual</h3>
                    <hr className='hr-gob' />
                </div>
                {
                    poa.map((item, index) => (
                        <div key={index} className='col-md-3 col-sm-6 col-12'>
                            <div className='card_container_poas'>
                                <div className='card_anio'>
                                    <h5>{item.anio}</h5>
                                   
                                    {
                                        item.trimestres.map((trim, index) => (
                                            <div key={index} className='card_trimestre'>
                                                <p>{trim.trimestre} <span className="badge bg-secondary">
                                                    <a href={trim.url} target="_blank">.pdf</a></span>
                                                </p>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    ))
                }
          </div>
        </div>
    )
}

export default Poasitem